module.exports = __webpack_public_path__ + "media/assets/fonts/Calibri-Bold-d2362af0b37d31196c7c91c60f9c87d1.ttf";